import {
  IPeerGroupsProps,
  getPeerGroupData,
  IFilter,
} from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";
import { Row, Col } from "react-bootstrap";
import { PercentFoundationsReceived } from "app/components/visualizations/PeerGroups/IncomingContributions/PercentFoundationsReceived";
import { AllFoundationLevelsBar } from "app/components/visualizations/PeerGroups/IncomingContributions/AllFoundationLevelsBar";
import { FoundationDistributionTable } from "app/components/visualizations/PeerGroups/IncomingContributions/FoundationDistributionTable";
import { TabHeader } from "app/components/tabs/header";

export interface IIncomingContributionsState {
  data: any[];
  currentPeerGroup: any[];
  filters: IFilter;
}

export class IncomingContributions extends React.Component<
  IPeerGroupsProps,
  IIncomingContributionsState
> {
  state: IIncomingContributionsState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  };

  componentDidMount() {
    this.pullData(this.props.filters);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters);
      });
    }
  }

  pullData(filters: IFilter) {
    const requestBody = {
      action: "getIncomingContributionsTab",
      request: { assetLevel: filters.assetLevel },
    };
    getPeerGroupData(requestBody).then((response: any[]) => {
      const currentPeerGroup = response.find(
        (dataPoint) => dataPoint.filterId === this.props.filters.assetLevel
      );
      this.setState({ data: response, currentPeerGroup });
    });
  }

  updateFilterId(filterId: number) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(filterId);
    }
  }

  render() {
    const { data, currentPeerGroup } = this.state;

    return (
      <div>
        <TabHeader
          filters={this.props.filters}
          label="Incoming Contributions"
        />
        <Row>
          <Col sm={12} md={6} className="text-center">
            <h4>Incoming Contributions</h4>
            <h4 className="text-primary">
              {currentPeerGroup && currentPeerGroup["InvOver_T_B_TotIncCon"]}
            </h4>
          </Col>
          <Col
            sm={12}
            md={6}
            className="fontSize1_7 text-center"
            style={{ padding: "25px" }}
          >
            <p>
              {currentPeerGroup && currentPeerGroup["IncCon_T_B_IncomingTotal"]}
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6}>
            <PercentFoundationsReceived
              data={data}
              filters={this.props.filters}
            />
          </Col>
          <Col sm={12} md={6}>
            <AllFoundationLevelsBar
              data={data}
              filters={this.props.filters}
              onChangeFilterId={(filterId) => {
                this.updateFilterId(filterId);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <FoundationDistributionTable
              data={data}
              filters={this.props.filters}
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/IncomingContributions.tsx